export const UPDATE_BUILDINGS = 'UPDATE_BUILDINGS'

export const updateBuildings = (value, id) => {
    // console.log('updateBuildings', value, id)

    return (dispatch, prevState) => {
        // console.log('pre', prevState())
        const oldBuildings = prevState().buildings
        const newBuilings = oldBuildings.map(el => {
            if(el.id !== id){
                return el
            } else {
                return {
                    ...el,
                    value: value
                }
            }
        })
        // console.log('newBuilings', newBuilings)
        localStorage.setItem('EHPBuildings', JSON.stringify(newBuilings))
        dispatch({
            type: UPDATE_BUILDINGS,
            buildings: newBuilings
        })
    }
}